export const SITE_CONTEXT = Object.freeze({
  B2B: 'b2b',
  TREK_B2C: 'trekB2c',
  ELECTRA_B2C: 'electraB2c',
});
